function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "e"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path",
  d: "M0,0H16V16H0Z",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  id: "Shape",
  d: "M7.15,13a1.286,1.286,0,0,1-.916-.376L.383,6.773A1.3,1.3,0,0,1,0,5.85V1.3A1.3,1.3,0,0,1,1.3,0H5.85a1.286,1.286,0,0,1,.916.377l5.85,5.85A1.314,1.314,0,0,1,13,7.15a1.265,1.265,0,0,1-.383.917l-4.55,4.55A1.265,1.265,0,0,1,7.15,13ZM2,1A1,1,0,1,0,3,2,1,1,0,0,0,2,1Z",
  transform: "translate(2 2)"
}));

var SvgIconTicket = function SvgIconTicket(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icon_Price",
    "data-name": "Icon Price",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "#878787",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconTicket, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-ticket.ad96601e.svg";
export { ForwardRef as ReactComponent };